var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + postfix).toString(36));
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/uid.js
// module id = 72
// module chunks = 0